





















import { GetInstanceTransactionResponse } from '@/classes/TayehApi/Instance';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class InvoiceViewerTransactionsTable extends Vue {
    @Prop() transactions: GetInstanceTransactionResponse[];
    @Prop() type: 'bought'|'sold'|'income'|'cost';

    // @Watch('transactions')
    // change () {
    //     console.log(this.transactions);
        
    // }

    
    public get isATrade() : boolean {
        return ['bought', 'sold'].indexOf(this.type)!==-1;
    }

    
    public get totalLabel() : string {
        return {
            bought: 'قیمت کل',
            sold: 'قیمت کل',
            income: ' درآمد',
            cost: 'هزینه',
        }[this.type];
    }
    
    
}
